import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class SavedReportFilters
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Row, Col, Input, FormGroup, ModalBody, ModalFooter } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import Loader from '../common/loader';
import ReportFilter from './reportFilter';
const stringToValues = (str, entity) => {
  let result = [];
  if (typeof str === 'string' && str.length > 0) {
    let names = str.split(',');
    names = names.filter(name => name.length > 0);
    if (names.length > 0) {
      result = names.map(name => ({
        name,
        id: name,
        entity
      }));
    }
  }
  return result;
};
const contentTitleToValues = forms => {
  let result = [];
  if (Array.isArray(forms)) {
    result = forms.map(form => {
      const id = form.id,
        _form$formType = form.formType,
        _form$formType2 = _form$formType === void 0 ? {} : _form$formType,
        _form$formType2$name = _form$formType2.name,
        name = _form$formType2$name === void 0 ? '' : _form$formType2$name,
        formTypeIdentifier = form.formTypeIdentifier,
        _form$content = form.content,
        contentStr = _form$content === void 0 ? '{}' : _form$content;
      const content = JSON.parse(contentStr);
      const _content$title = content.title,
        title = _content$title === void 0 ? '' : _content$title;
      return {
        name: title,
        id,
        entity: name,
        formTypeIdentifier
      };
    });
  }
  return result;
};

/* eslint-disable-next-line default-param-last */
const cleanForFilterOptionData = function cleanForFilterOptionData() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let entity = arguments.length > 1 ? arguments[1] : undefined;
  // uppercase first letter
  const entityName = entity.charAt(0).toUpperCase() + entity.slice(1);
  return options.map(option => {
    const tmp = {
      name: option.name,
      id: option.id,
      entity: entityName
    };
    if (option.jobID) {
      tmp.jobID = option.jobID;
    }
    return tmp;
  });
};
const addToFilterVals = (existingVals, newVals) => {
  if (existingVals) {
    return existingVals.concat(newVals);
  }
  return newVals;
};

/**
 * this maps from saved report filter to a filter selection.
 * we have all the properties in the object, so we have to filter
 * it for the interesting/useful stuff.
 */
const convertReportFiltersToSelectedFilter = reportFilter => {
  const result = {};
  const addKeyValsToResult = (key, values) => {
    if (values.length > 0) {
      const options = addToFilterVals(result[key], values);
      result[key] = cleanForFilterOptionData(options, key);
    }
  };
  const storeNameToFilterName = {
    assets: 'asset',
    assetsTypes: 'asset',
    assetTypeOthers: 'asset',
    assetCategoryNames: 'asset',
    weekEnding: 'weekEnding',
    jobPieces: 'jobPiece',
    jobPieceSections: 'jobPiece',
    jobPieceOthers: 'pieceOther',
    jobs: 'job',
    jobPhaseCodes: 'jobPhaseCode',
    currentStates: 'currentState',
    organizations: 'organization',
    reportAssignments: 'reportAssignment',
    reportTypes: 'reportType',
    reportTags: 'reportTag',
    statuses: 'status',
    issueSeverities: 'issueSeverity',
    forms: 'form',
    creators: 'user'
  };
  (Object.keys(reportFilter) || []).forEach(key => {
    const value = reportFilter[key];
    let values;
    switch (key) {
      case 'weekEnding':
        values = stringToValues(value, 'WeekEnding');
        addKeyValsToResult(storeNameToFilterName[key], values);
        break;
      case 'assetCategoryNames':
        values = stringToValues(value, 'AssetCategory');
        addKeyValsToResult(storeNameToFilterName[key], values);
        break;
      case 'forms':
        values = contentTitleToValues(value);
        addKeyValsToResult(storeNameToFilterName[key], values);
        break;
      default:
        if (storeNameToFilterName[key]) {
          addKeyValsToResult(storeNameToFilterName[key], value);
        }
        break;
    }
  });
  return result;
};
const extractAndSetEntity = (incomingResult, filterName, entities) => {
  const result = incomingResult;
  let deleteit = true;
  if (result[filterName]) {
    const entityKeys = Object.keys(entities);
    entityKeys.map(entity => {
      const newFilterName = entities[entity];
      if (newFilterName === filterName) {
        deleteit = false;
      }
      // split this into jobPieces and jobPieceSection
      const filterVals = result[filterName].filter(item => item.entity.toLowerCase() === entity.toLowerCase());
      if (filterVals.length > 0) {
        if (Array.isArray(result[newFilterName])) {
          result[newFilterName] = result[newFilterName].concat(filterVals);
        } else {
          result[newFilterName] = filterVals;
        }
      }
      return true;
    });
    if (deleteit) {
      delete result[filterName];
    }
  }
  return result;
};

/**
 *  this method takes the currently selected filters
 *  and converts them into reportFilter data that
 *  can be saved.  Unfortunately, there is not a one
 *  to one correspondence, so we need to massage the
 *  data - some fields more than others.
 */
const convertSelectedFiltersToReportFilter = filters => {
  let result = {};
  Object.keys(filters).forEach(key => {
    const val = filters[key];
    let newVal = val;
    switch (key) {
      case 'weekEnding':
        newVal = (val || []).map(next => next.name).join(',');
        break;
      default:
        break;
    }
    result[key] = newVal;
  });
  if (result.asset) {
    const categories = result.asset.filter(item => item.entity.toLowerCase() === 'AssetCategory'.toLowerCase());
    if (categories && categories.length > 0) {
      result.assetCategories = (categories || []).map(next => next.name).join(',');
    }
  }
  result = extractAndSetEntity(result, 'asset', {
    Asset: 'assets',
    AssetType: 'assetTypes'
  });
  result = extractAndSetEntity(result, 'jobPiece', {
    JobPiece: 'jobPieces',
    JobPieceSection: 'jobPieceSections'
  });

  // also include sectionName in job piece selections
  if (result.jobPieceSections && result.jobPieceSections.length > 0) {
    result.jobPieceSections = result.jobPieceSections.map(jps => _objectSpread(_objectSpread({}, jps), {}, {
      sectionName: jps.name
    }));
  }
  result = extractAndSetEntity(result, 'pieceOther', {
    PieceOther: 'jobPieceOthers',
    PieceOtherParent: 'jobPieceOtherParents'
  });
  result = extractAndSetEntity(result, 'job', {
    Job: 'jobs'
  });
  result = extractAndSetEntity(result, 'organization', {
    Organization: 'organizations'
  });
  result = extractAndSetEntity(result, 'reportAssignment', {
    ReportAssignment: 'reportAssignments'
  });
  result = extractAndSetEntity(result, 'currentState', {
    CurrentState: 'currentStates'
  });
  result = extractAndSetEntity(result, 'jobPhaseCode', {
    JobPhaseCode: 'jobPhaseCodes'
  });
  result = extractAndSetEntity(result, 'reportType', {
    ReportType: 'reportTypes'
  });
  result = extractAndSetEntity(result, 'status', {
    Status: 'statuses'
  });
  result = extractAndSetEntity(result, 'reportTag', {
    ReportTag: 'reportTags'
  });
  result = extractAndSetEntity(result, 'user', {
    User: 'creators'
  });
  result = extractAndSetEntity(result, 'issueSeverity', {
    IssueSeverity: 'issueSeverities'
  });
  result = extractAndSetEntity(result, 'form', {
    Form: 'forms'
  });
  return result;
};
export default class SavedReportFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCreateFilter = this.handleCreateFilter.bind(this);
    this.handleFilterNameChange = this.handleFilterNameChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.anyFiltersSet = this.anyFiltersSet.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      reportFilter = _this$props.reportFilter,
      reportFilterActions = _this$props.reportFilterActions;
    // send off a query to get all the saved report filters for the logged in user.
    reportFilterActions.serverIndex(reportFilter.indexQuery);
  }
  componentDidUpdate(prevProps) {
    const _this$props2 = this.props,
      reportFilterActions = _this$props2.reportFilterActions,
      reportFilter = _this$props2.reportFilter;
    if (prevProps.reportFilter.loading === true && reportFilter.loading === false && prevProps.reportFilter.pendingChanges === true && reportFilter.pendingChanges === false) {
      // when finished saving a new reportFilter, re-fetch the list.
      reportFilterActions.serverIndex(reportFilter.indexQuery);
    }
  }
  handleCancel() {
    const reportFilterActions = this.props.reportFilterActions;
    reportFilterActions.showCancel();
    this.setState({
      isOpen: false
    });
  }
  handleCreateFilter() {
    const _this$props3 = this.props,
      reportIndexQuery = _this$props3.reportIndexQuery,
      reportFilterActions = _this$props3.reportFilterActions,
      userID = _this$props3.userID;
    const reportFilters = convertSelectedFiltersToReportFilter(reportIndexQuery.filters);
    reportFilterActions.create(uuidV4().toUpperCase(), userID, reportFilters);
    this.setState({
      isOpen: true
    });
  }
  handleFilterNameChange(ev) {
    const _this$props4 = this.props,
      reportFilter = _this$props4.reportFilter,
      reportFilterActions = _this$props4.reportFilterActions;
    reportFilterActions.change(reportFilter.active.id, 'name', ev.target.value);
  }
  handleRemove(reportFilter) {
    const reportFilterActions = this.props.reportFilterActions;
    reportFilterActions.serverDestroy(reportFilter.id);
  }
  handleSave() {
    const _this$props5 = this.props,
      reportFilter = _this$props5.reportFilter,
      reportFilterActions = _this$props5.reportFilterActions;
    reportFilterActions.serverSave(reportFilter.active);
    this.setState({
      isOpen: false
    });
  }

  /**
   * this maps from a saved report filter to the setting the values on the
   * actual filters being used.
   *
   * @param reportFilters
   * @private
   */
  handleSelect(reportFilter) {
    const _this$props6 = this.props,
      reportActions = _this$props6.reportActions,
      reportIndexQuery = _this$props6.reportIndexQuery;
    const result = convertReportFiltersToSelectedFilter(reportFilter);
    reportActions.serverFilter(result, reportIndexQuery);
  }
  anyFiltersSet() {
    const filters = this.props.reportIndexQuery.filters;
    return Object.values(filters).filter(value => value != null).length > 0;
  }
  render() {
    const _this$props$reportFil = this.props.reportFilter,
      active = _this$props$reportFil.active,
      list = _this$props$reportFil.list,
      loading = _this$props$reportFil.loading;
    const isOpen = this.state.isOpen;
    return /*#__PURE__*/React.createElement("div", null, this.anyFiltersSet() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleCreateFilter,
      className: "float-md-left t-srf-save"
    }, "Save Current Filters")) : undefined, /*#__PURE__*/React.createElement("div", {
      style: {
        clear: 'both',
        marginBottom: '10px'
      }
    }), list.length > 0 ? list.map(reportFilter => /*#__PURE__*/React.createElement(ReportFilter, {
      key: reportFilter.id,
      onSelect: this.handleSelect,
      onRemove: this.handleRemove,
      reportFilter: reportFilter
    })) : /*#__PURE__*/React.createElement("p", null, "No saved filters yet."), loading ? /*#__PURE__*/React.createElement(Loader, {
      top: "50%"
    }) : undefined, isOpen ? /*#__PURE__*/React.createElement(Modal, {
      isOpen: isOpen,
      toggle: this.handleCancel
    }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h2", null, "Create Filter"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Input, {
      id: "filterNameInput",
      type: "text",
      name: "filterName",
      value: active.name,
      onChange: this.handleFilterNameChange,
      placeholder: "filter name"
    }))))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleCancel
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleSave
    }, "Create"))) : undefined);
  }
}
SavedReportFilters.propTypes = {
  reportFilter: PropTypes.shape({
    id: PropTypes.string,
    active: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    }),
    indexQuery: PropTypes.shape({
      sortDirection: PropTypes.string
    }),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool
  }).isRequired,
  reportFilterActions: PropTypes.shape({
    create: PropTypes.func,
    change: PropTypes.func,
    serverDestroy: PropTypes.func,
    serverIndex: PropTypes.func,
    serverSave: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};